var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('navigation-bar',{attrs:{"hidden":_vm.hideNavBar}}),_c('v-main',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('router-view',{key:_vm.$route.fullPath,on:{"hide-nav-bar":_vm.handleNavBarVisibilityChange}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }